export default __webpack_public_path__ + "static/media/house-keeper.95bcf8bf.svg";